
import { Component, Vue, Prop } from 'vue-property-decorator'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'
import { CommonSearchIVO, CommonSearchOVO } from '@/views/biz/omr/vo/SearchVO.vo'
import { WrongAnswerNoteOVO } from '@/views/biz/note/vo/WrongAnswerNote.vo'
import axios from 'axios'

@Component
export default class WrongAnswerNoteMain extends Vue {
  WrongAnswerNotes: Array<WrongAnswerNoteOVO> = [] as Array<WrongAnswerNoteOVO>

  created(): void {
    // 오답노트 조회
    axios.get('/wrong-answer-note/wrong-answer-notes')
    .then(r => {
      this.WrongAnswerNotes = r.data;
    })
  }
  
}
